"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONT_FACE = exports.FONT_WEIGHT = void 0;
var FONT_WEIGHT = {
  ULTRALIGHT: 'ultraLight',
  LIGHT: 'light',
  REGULAR: 'regular',
  SEMIBOLD: 'semibold',
  BOLD: 'bold'
};
exports.FONT_WEIGHT = FONT_WEIGHT;
var FONT_FACE = {
  MONOSPACE: 'monospace',
  BODY: 'body',
  HEADING: 'heading'
};
exports.FONT_FACE = FONT_FACE;